import React, { useState } from 'react';
import _classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import LazyAnimation from './LazyAnimation';

const useStyles = makeStyles(theme => ({
  container: {
    width: '89%',
    maxWidth: '89%',
    padding: '27px 0',
    margin: 'auto',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  wrapper: {
    width: '27%',
    zIndex: 1,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  header: {
    cursor: 'pointer',
    color: '#FFFFFF',
    width: '100%',
    position: 'relative',
    fontSize: 15,
    fontFamily: 'MontserratSemiBold',
    fontWeight: '600',
    padding: '0 20px',
    textTransform: 'uppercase',
    transition: 'all 600ms ease 0ms',
    '& > svg': {
      position: 'absolute',
      right: 0,
    },
  },
  list: {
    width: '100%',
    backgroundColor: '#E09900',
    padding: 20,
    transition: 'all 600ms ease 0ms',
    overflow: 'hidden',
  },
  listOpen: {
    height: 'auto',
    backgroundColor: '#000000',
  },
  listItem: {
    color: '#FFFFFF',
    fontFamily: 'OpenSansRegular',
    lineHeight: '1.7em',
    fontSize: 14,
    marginTop: '1em',
  },
  box: {
    maxHeight: 0,
    height: 0,
    transition: 'all 600ms ease 0ms',
    transformOrigin: 'top left',
    overflow: 'hidden',
  },
  boxOpen: {
    maxHeight: 1500,
    height: 'auto',
  },
}));

function ExpertsList() {
  const classes = useStyles();
  const [isOpen, setOpen] = useState(false);

  const handleClick = () => setOpen(!isOpen);

  const experts = [
    {
      id: 'pamela-alexander-phd',
      content: (
        <span>
          <b>Pamela Alexander, PhD – </b>Author: Trauma topic write-up;{' '}
          <i>PhD in Psychotherapy from Emory University</i>
        </span>
      ),
    },
    {
      id: 'thais-araujo-md',
      content: (
        <span>
          <b>Thais Araujo, MD – </b>Co-author: Bodywork topic write-up;{' '}
          <i>MD from Federal University of Minas Gerais (Brazil)</i>
        </span>
      ),
    },
    {
      id: 'mark-forman-phd',
      content: (
        <span>
          <b>Mark Forman, PhD – </b>Author: Therapy & Support Groups topic
          write-up;{' '}
          <i>
            PhD in Clinical Psychology from the Institute of Transpersonal
            Psychology
          </i>
        </span>
      ),
    },
    {
      id: 'oliver-grundmann-phd',
      content: (
        <span>
          <b>Oliver Grundmann, PhD – </b>Author: Herbs & Supplements topic
          write-up;{' '}
          <i>
            PhD in Pharmaceutical Sciences and MS in Forensic Toxicology from
            University of Florida
          </i>
        </span>
      ),
    },
    {
      id: 'kelsey-laird-phd',
      content: (
        <span>
          <b>Kelsey Laird, PhD – </b>Author: Compassion, Meaning and Purpose,
          Meditation, Mindfulness, Psychedelics & Entheogens topic write-ups;{' '}
          <i>PhD in Psychology from Vanderbilt University</i>
        </span>
      ),
    },
    {
      id: 'justin-laube-md',
      content: (
        <span>
          <b>Justin Laube, MD – </b>Author: Bodywork topic write-up;{' '}
          <i>MD from University of Minnesota Medical School</i>
        </span>
      ),
    },
    {
      id: 'carol-normandi-lfmt',
      content: (
        <span>
          <b>Carol Normandi, LFMT – </b>Author: Body Image and Eating Behaviors
          topic write-ups;{' '}
          <i>MS in Counseling Psychology from San Francisco State University</i>
        </span>
      ),
    },
    {
      id: 'stefan-richter-md',
      content: (
        <span>
          <b>Stefan Richter, MD, </b>PhD – Author: Breathwork, End-of-Life Care,
          and Psychedelics & Entheogens topic write-ups;{' '}
          <i>
            MD from University of Michigan; PhD in Health Policy and Management
            from UCLA{' '}
          </i>
        </span>
      ),
    },
    {
      id: 'jennifer-stern-lisw',
      content: (
        <span>
          <b>Jennifer Stern, LISW – </b>Author: Grief & Loss topic write-up;{' '}
          <i>MA in Clinical Social Work from University of Chicago </i>
        </span>
      ),
    },
    {
      id: 'andrea-ruf-phd',
      content: (
        <span>
          <b>Andrea Ruf, PhD – </b>Author: Stress topic write-up;{' '}
          <i>
            PhD in Public Health from Federal University of Bahia and University
            of Zurich
          </i>
        </span>
      ),
    },
    {
      id: 'mark-schmanko-ma-phd-candidate',
      content: (
        <span>
          <b>Mark Schmanko, MA, PhD Candidate – </b>Author: Spirituality, Yoga,
          and Self- Transcendence topic write-ups;{' '}
          <i>
            PhD candidate in Religion from Rice University; MA from Harvard
            University
          </i>
        </span>
      ),
    },
    {
      id: 'catherine-ulbricht-pharmd-mba',
      content: (
        <span>
          <b>Catherine Ulbricht, PharmD, MBA – </b>Expert Editor: Herbs &
          Supplements write-up;{' '}
          <i>
            PharmD from the Massachusetts College of Pharmacy and Health
            Sciences
          </i>
        </span>
      ),
    },
    {
      id: 'scott-weiner-md-mph',
      content: (
        <span>
          <b>Scott Weiner, MD, MPH – </b>Author: Addiction & Recovery topic
          write-up; MD from University of California, Irvine;{' '}
          <i>
            MPH from Harvard School of Public Health; Assistant Professor of
            Emergency Medicine, Harvard Medical School
          </i>
        </span>
      ),
    },
  ];

  return (
    <div className={classes.container}>
      <div className={classes.wrapper}>
        <LazyAnimation type="scale-up-0 fade-in">
          <div
            className={_classNames({
              [classes.list]: true,
              [classes.listOpen]: isOpen,
            })}
          >
            <Typography
              className={classes.header}
              onClick={handleClick}
              role="button"
              tabIndex={0}
            >
              Team of Clinical Experts{' '}
              {isOpen ? <RemoveCircleIcon /> : <AddCircleIcon />}
            </Typography>
            <div
              className={_classNames({
                [classes.box]: true,
                [classes.boxOpen]: isOpen,
              })}
            >
              {experts.map(expert => (
                <Typography className={classes.listItem} key={expert.id}>
                  {expert.content}
                </Typography>
              ))}
            </div>
          </div>
        </LazyAnimation>
      </div>
    </div>
  );
}

export default ExpertsList;
